// extracted by mini-css-extract-plugin
module.exports = {"contactForm":"_1v2ez4ehOm1pyZv0JY-ocd","inputGroup":"_1M86m_VhLANV0Lp1Us0YHi","legal":"_3WgL8AEruzslU5RptMARK1","amountInput":"g7lBIYi0csUyvQPix2wqw"};